module.exports = __webpack_public_path__ + "static/media/previous-period-line-purple.d9789308.svg";